import { Typography } from '@breetometer/components';
import { WalletIcon } from 'BreetAssets';
import { capitalizeFirstLetter } from 'BreetHelpers';
import { useCryptoSettingsApi } from 'BreetHooks';

import { SkeletonLoader } from '../Loader';
import { getReceiveCurrencyLabel } from './ReceiveCurrencyBadge.helpers';

const ReceiveCurrencyBadge = () => {
	const { currentReceiveCurrency, isLoading } = useCryptoSettingsApi();

	return (
		<span className='receivecurrencybadge bg-primary-400 border-dark-navy'>
			<WalletIcon variant='wallet-2' />
			{isLoading ? (
				<SkeletonLoader height='1.6rem' />
			) : (
				<Typography
					as='span'
					variant='paragraph_2'
				>
					{capitalizeFirstLetter(getReceiveCurrencyLabel(currentReceiveCurrency))}&nbsp;Wallet
				</Typography>
			)}
		</span>
	);
};

export default ReceiveCurrencyBadge;
